import './style.scss'
import React from 'react'
import styled from 'styled-components'
import { tokens, rem, UIProps } from 'src/componentv2/Base/ui'

export interface ProgressBarProps extends UIProps {
    value?: number
    max?: number
    trackColor?: string
}

const Track = styled.div<ProgressBarProps>`
    width: ${({ width }) => rem(width) ?? '100%'};
    height: ${({ height }) => rem(height) ?? '0.6rem'};
    background: ${({ trackColor }) => trackColor ?? '#D0EFEC'};
    border-radius: 999rem;
    overflow: hidden;
`

const Fill = styled.div<{ pct: number; fill?: string }>`
    height: 100%;
    width: ${({ pct }) => `${pct}%`};
    background: ${({ fill }) => fill ?? tokens.primary};
    border-radius: 999rem;
    transition: width 0.4s ease;
`

export const ProgressBar: React.FC<ProgressBarProps> = ({
                                                            value = 0, max = 100, bgColor, className = '', ...rest
                                                        }) => {
    const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0
    return (
        <Track className={`progress ${className}`} {...rest}>
            <Fill pct={pct} fill={bgColor} />
        </Track>
    )
}

export default ProgressBar